import { PageViewIdActionTypes } from '@redux/actions/types';

export const changeHomePageViewId = (pageViewId: string) => ({
  type: PageViewIdActionTypes.ChangeHomePageViewId,
  payload: pageViewId,
});
